import config from './config.json';

export const { brandLogo, brandName } = config;
